import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import StatsSection from "../sections/StatsSection";

export function StatsPage({ stats }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Статистика"
        description="Тренды регистраций, активные пользователи, количество подписок и оценка выручки."
      />
      <PageContent>
        <StatsSection mode="page" stats={stats} />
      </PageContent>
    </div>
  );
}

export default StatsPage;
